export const STORE_CONFIG = {
  // UPDATE THESE COORDINATES TO YOUR ACTUAL STORE LOCATION
  location: {
    lat: -25.76837, // Replace with your store's latitude
    lng: 28.43424,  // Replace with your store's longitude
    address: "Plot 365, cnr R104 (Old Bronkhortspruit Road) and R964 (Donkerhoek road), Donkerhoek, Pretoria East, 0185, South Africa", // Replace with actual address
    name: "Koöperasie Veevoer Winkel" // Replace with actual store name
  },
  
  // Contact information
  contact: {
    email: "delivery@veevoerwinkel.co.za", // Replace with actual delivery email
    phone: "+27 61 321 5050", // Replace with actual phone number
    whatsapp: "+27 61 321 5050" // Replace with WhatsApp number if different
  },
  
  // Business hours for delivery calculations
  businessHours: {
    weekday: { start: "08:00", end: "17:00" },
    saturday: { start: "08:00", end: "13:00" },
    sunday: { start: "closed", end: "closed" }
  },
  
  // Default calculation preferences
  defaults: {
    calculationMethod: "simple", // Default to simple calculation
    currency: "ZAR",
    currencySymbol: "R"
  }
};